import "./tabs.css";
import { useDispatch } from "react-redux";

const StoreTabs = ({ switchPage, storeIsOnlineOnly, noProductCreated }) => {
  const dispatch = useDispatch();
  const switchTab = (e, pageName) => {
    console.log("switching tab");

    let target = e.target;
    let siblings = target.parentNode.children;
    Array.from(siblings).forEach((sibling) => {
      sibling.classList.remove("activeStoreTab");
    });
    target.classList.add("activeStoreTab");
    dispatch(switchPage(pageName));
  };
  return (
    <>
      <div className='storeTabWrapper'>
        <div className='StoreTabDIv'>
          {!storeIsOnlineOnly && (
            <p onClick={(e) => switchTab(e, "transaction")} className={!noProductCreated ? "activeStoreTab" : ""}>
              Sell products
            </p>
          )}
          <p onClick={(e) => switchTab(e, "receivedOrder")} className={storeIsOnlineOnly && !noProductCreated ? "activeStoreTab" : ""}>
            {" "}
            {/* online store and products already created */}
            Received orders
          </p>
          <p onClick={(e) => switchTab(e, "advertisement")}>Advertisement</p>
          <p className={noProductCreated ? "activeStoreTab" : ""} onClick={(e) => switchTab(e, "stockManagement")}>
            Stock Management
          </p>
          <p onClick={(e) => switchTab(e, "messages")}>Messages</p>
          <p onClick={(e) => switchTab(e, "expenses")}>Expenses</p>
          <p onClick={(e) => switchTab(e, "storeProfile")}>Store profile</p>
        </div>
      </div>
    </>
  );
};

export default StoreTabs;
